import AuthGuard, { AuthFlow } from '@components/AuthGuard';
import Button from '@components/Button';
import Row from '@components/Row';
import { css } from '@emotion/react';
import { ItemResponse } from '@models/item';
import { Link } from '@stackflow/link';
import { useItemActivityId } from '@store/item/context/ItemActivityContext';
import { useTranslation } from 'react-i18next';

import useAddCart from './hooks/useAddCart';
import OptionSelectionGuard from './OptionSelectionGuard';

interface Props {
    shopId: string;
    isSoldOut: boolean;
    item: ItemResponse;
}

function OrderRow({ shopId, isSoldOut, item }:Props) {
    const { t } = useTranslation('item');
    const itemId = item.id;
    const activityId = useItemActivityId();
    const { handleAddToCart } = useAddCart(shopId);
    const authFlows: AuthFlow[] = [
        { activityName: 'ShopListActivity', activityParams: { isOrder: false, type: 'LIST' } },
        { activityName: 'ItemsActivity', activityParams: { shopId, type: 'ALL' } },
        { activityName: 'ItemActivity', activityParams: { itemId, shopId } },
    ];
    return (
        <Row spacing={4} >
            <Row fullWidth spacing={2}>
                <AuthGuard flows={authFlows}>
                    <OptionSelectionGuard item={item}>
                        <Button fullWidth variant='tone'
                            onClick={handleAddToCart}
                            noPadding>
                            {t('footer.addToCart')}
                        </Button>
                    </OptionSelectionGuard>
                </AuthGuard>
                <AuthGuard flows={authFlows}>
                    <OptionSelectionGuard item={item}>
                        <Link activityName='OrderActivity'
                            activityParams={{ path: 'direct', itemActivityId: activityId }}
                            css={css`width: 100%`} >
                            <Button fullWidth
                                disabled={isSoldOut}
                                noPadding>
                                {isSoldOut ? t('footer.soldOut') : t('footer.orderNow')}
                            </Button>
                        </Link>
                    </OptionSelectionGuard>
                </AuthGuard>
            </Row>
        </Row>
    );
}

export default OrderRow;
